// Add N calendar days to a yyyy-MM-dd string, returns yyyy-MM-dd
function addDays(dateStr, n) {
  const parts = dateStr.split('-');
  // Use noon UTC to avoid DST/timezone edge cases
  const d = new Date(Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]), 12, 0, 0));
  d.setUTCDate(d.getUTCDate() + n);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// 0=Sun,1=Mon,...,6=Sat
function getDayOfWeek(dateStr) {
  const parts = dateStr.split('-');
  const d = new Date(Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]), 12, 0, 0));
  return d.getUTCDay();
}

const extendBarData = (barData, numBars) => {
  if (!barData || !barData.dates || barData.dates.length === 0) {
    return { ohlc: [], dates: [], volumes: [] };
  }

  const newDates = [...barData.dates];
  const newOhlc = [...barData.ohlc];
  const newVolumes = [...barData.volumes];

  const lastDateStr = newDates[newDates.length - 1].split('T')[0];
  const lastPrice = newOhlc[newOhlc.length - 1][1]; // Use last close price

  let added = 0;
  let dayOffset = 0;
  while (added < numBars) {
    dayOffset++;
    const candidate = addDays(lastDateStr, dayOffset);
    const dow = getDayOfWeek(candidate);
    if (dow === 0 || dow === 6) continue; // skip Sun/Sat
    newDates.push(candidate);
    newOhlc.push([lastPrice, lastPrice, lastPrice, lastPrice]); // Placeholder OHLC
    newVolumes.push(0); // Placeholder volume
    added++;
  }

  // Deduplicate consecutive duplicate dates (and corresponding ohlc/volumes)
  const dedupedDates = [];
  const dedupedOhlc = [];
  const dedupedVolumes = [];
  for (let i = 0; i < newDates.length; ++i) {
    if (i === 0 || newDates[i] !== newDates[i - 1]) {
      dedupedDates.push(newDates[i]);
      dedupedOhlc.push(newOhlc[i]);
      dedupedVolumes.push(newVolumes[i]);
    }
  }
  return {
    ...barData,
    dates: dedupedDates,
    ohlc: dedupedOhlc,
    volumes: dedupedVolumes,
  };
};

export { extendBarData };
